<template>
    <div class="trade">
        <div id="navTitle">
            <img class="black" @click="back" src="@/assets/images/template/a_top_return.png"/>
            <span>{{$t("trade.tab.market")}}</span>
        </div>
        <div id="content">
            <div class="priceCon" :class="user.loginname?'priceCon':'priceCon noLogin'">
                <ul>
                    <li><span>{{user.loginname&&account.balance?Number(util.accSub(util.accAdd(account.balance,profitTotal || 0),account.take || 0)).toFixed(2):'--'}}</span><p>{{$t('trade.products.available')}}({{$t('trade.USD')}})</p></li>
                    <li><span :class="profitClass(profitTotal)"><em>+</em>{{user.loginname&&profitTotal?Number(profitTotal || 0.00).toFixed(2):'--'}}</span><p>{{$t('trade.products.realTimeProfitLoss')}}({{$t('trade.USD')}})</p></li>
                </ul>
            </div>
            <NoLogin v-if="user.loginname?noLogin:login"></NoLogin>
            <div v-if="user.loginname?login:noLogin" class="tradeCon">
                <div class="tradeNav">
                    <ul>
                        <li v-for='(item,index) in tabs' :class="{checked:isTrue==index}" @click="tabclick(index)" ><span>{{ item.name }}</span><p></p></li>
                    </ul>
                </div>
                <div class="tradeList" v-if="isTrue==0">
                    <Position></Position>
                </div>
                <div class="tradeList" v-if="isTrue==1">
                    <Pending></Pending>
                </div>
                <div class="tradeList" v-if="isTrue==2">
                    <DayDeal></DayDeal>
                </div>
                <div class="tradeList" v-if="isTrue==3">
                    <DayProfit></DayProfit>
                </div>
                <div class="tradeList" v-if="isTrue==4">
                    <More></More>
                </div>
            </div>
        </div>
        <tab></tab>
    </div>
</template>
<script>
    require('@/assets/css/trade.css');
    import Tab from '@/view/module/Tab.vue'
    import Position from './position/Position.vue'
    import Pending from './position/Pending.vue'
    import DayDeal from './position/DayDeal.vue'
    import DayProfit from './position/DayProfit.vue'
    import NoLogin from '@/view/module/NoLogin.vue'
    import More from './position/More.vue'
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import TradeUtil from '@/utils/tradeUtil'
    export default {
        name: "Trade",
        components: {
            Tab,Position, Pending, DayDeal, DayProfit, More,NoLogin
        },
        data() {
            return {
                util:Util,
                isShow: false,
                isChoose: true,
                isTrue: 0,
                tabs: [
                    {name: this.$t('trade.products.positionOrder'),},
                    {name: this.$t('trade.products.pendingOrder'),},
                    {name: this.$t('trade.products.transactionDay'),},
                    {name: this.$t('trade.products.ProfitLossDay'),},
                    {name: this.$t('trade.products.more'),},
                ],
                noLogin:false,
                login:true
            }
        },
        computed: {
            ...mapState(['account','tradeData','quote',"user"]),
            /*盈亏*/
            profitTotal:{
                get(){
                    if (this.tradeData.position.length <= 0) return 0;
                    const data = this.tradeData.position;
                    let total = 0.00;
                    for (let i in data) {
                        if (!this.quote.symbolTickMap[data[i].SName.szShortName]) return null;
                        let sub = 0;
                        if (data[i].Direction == 1){//买
                            sub = Util.accSub(this.quote.symbolTickMap[data[i].SName.szShortName].ask,data[i].OpenPrice);
                        }else{
                            sub = Util.accSub(data[i].OpenPrice,this.quote.symbolTickMap[data[i].SName.szShortName].bid);
                        }
                        let profit = TradeUtil.changeCurrency(sub,this.quote.symbolTickMap[data[i].SName.szShortName].ask,this.quote.symbolTickMap[data[i].SName.szShortName].bid,data[i].Volume,data[i].symbolData,this.quote.symbolTickMap,data[i].Direction);
                        total = Util.accAdd(total,profit);
                        total = Util.accAdd(total,data[i].Swap);
                    }
                    return Number(total).toFixed(2);
                }
            }
        },
        methods: {
            back() {
                this.$router.push({path: '/home'})
            },
            tabclick: function (index) {
                this.$router.push({path:'/home/trade',query:{type:index}});
                this.isTrue = index;
                if (this.isTrue == 4) {
                    this.isChoose = !this.isChoose;
                } else {
                    this.isChoose = true
                }
                return this.isChoose;
            },
            profitClass:function (obj) {
                let val="";
                if (obj>0){
                    val="rise"
                }else if(obj==0){
                    val="level"
                }else {
                    val="fall"
                }
                return val;
            },
        },
        mounted() {
            window.scrollTo(0,0);
            this.$bus.$emit('loading', true);
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');
            if (this.$route.query.type) this.isTrue = this.$route.query.type;
        },
        activated(){
            this.$bus.$emit('loading', true);
        },
    }
</script>
